import React from "react";
import PropTypes from "prop-types";

export const FooterText = props => (
  <span>
    &copy; {1900 + new Date().getYear()}{" "}
    <a href="http://www.pondata.com/" className={props.anchor}>
      {props.rtlActive ? "توقيت الإبداعية" : "Pondata"}
    </a>
    {props.rtlActive
      ? ", مصنوعة مع الحب لشبكة الإنترنت أفضل"
      : ", made with love for a better web"}
    &nbsp;
    {`(${process.env.REACT_APP_GIT_SHA})`}
  </span>
);

FooterText.propTypes = {
  anchor: PropTypes.string.isRequired,
  rtlActive: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/Footer/FooterText.jsx